import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
} from '@backstage/core-plugin-api';

import {
  createRootRouteRefsPair,
  createSubRouteRefsPair,
} from '@spotify/confidence-core-react';

export enum RoutesIds {
  admin = 'admin',
  notifications = 'notifications',
  secrets = 'secrets',
  secret = 'secret',
  policies = 'policies',
  groups = 'groups',
  group = 'group',
  users = 'users',
  user = 'user',
  invitations = 'invitations',
  agents = 'agents',
  agent = 'agent',
  apiClients = 'apiClients',
  apiClient = 'apiClient',
  clients = 'clients',
  client = 'client',
  clientSchema = 'clientSchema',
  clientMonitoring = 'clientMonitoring',
  roles = 'roles',
  oauthApps = 'oauthApps',
  oauthApp = 'oauthApp',
  metricsDataWarehouse = 'metricsDataWarehouse',
  reports = 'reports',
  github = 'github',
  cursorIntegration = 'cursorIntegration',
  workflows = 'workflows',
  workflow = 'workflow',
  workflowInstances = 'workflowInstances',
  workflowInstanceOverview = 'workflowInstanceOverview',
  workflowInstanceEvents = 'workflowInstanceEvents',
  workflowLogs = 'workflowLogs',
  workflowTunnels = 'workflowTunnels',
  flagAppliedConnections = 'flagAppliedConnections',
  flagAppliedConnection = 'flagAppliedConnection',
  eventConnections = 'eventConnections',
  eventConnection = 'eventConnection',
  activityFeeds = 'activityFeeds',
  environments = 'environments',
  assignmentTables = 'assignmentTables',
  assignmentTable = 'assignmentTable',
  assignmentTablesCreate = 'assignmentTablesCreate',
  assignmentTableEdit = 'assignmentTableEdit',
  factTables = 'factTables',
  factTable = 'factTable',
  factTablesCreate = 'factTablesCreate',
  factTableEdit = 'factTableEdit',
  entities = 'entities',
  entity = 'entity',
  entityRelationTable = 'entityRelationTable',
  entityRelationTableCreate = 'entityRelationTableCreate',
  dimensionTables = 'dimensionTables',
  dimensionTable = 'dimensionTable',
  dimensionTableEdit = 'dimensionTableEdit',
  dimensionTablesCreate = 'dimensionTablesCreate',
  labels = 'labels',
  label = 'label',
  dataAgent = 'dataAgent',
}

enum ExternalRoutesIds {
  entity = 'entity',
  entities = 'entities',
  factTables = 'factTables',
  dimensionTables = 'dimensionTables',
}

// root route
export const [adminRouteImplRef, adminRouteRef] = createRootRouteRefsPair({
  id: RoutesIds.admin,
});

export const rootRouteRef = adminRouteImplRef;

// sub-routes within the plugin
export const [notificationsRouteImplRef, notificationsRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.notifications,
    parent: rootRouteRef,
    path: '/notifications',
  });

export const [workflowSecretsRouteImplRef, workflowSecretsRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.secrets,
    parent: rootRouteRef,
    path: '/workflow-secrets',
  });

export const [workflowSecretRouteImplRef, workflowSecretRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.secret,
    parent: rootRouteRef,
    path: '/workflow-secrets/:id',
  });

export const [policiesRouteImplRef, policiesRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.policies,
  parent: rootRouteRef,
  path: '/policies',
});

export const [groupsRouteImplRef, groupsRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.groups,
  parent: rootRouteRef,
  path: '/groups',
});

export const [groupRouteImplRef, groupRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.group,
  parent: rootRouteRef,
  path: '/groups/:id',
});

export const [usersRouteImplRef, usersRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.users,
  parent: rootRouteRef,
  path: '/users',
});

export const [invitationsRouteImplRef, invitationsRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.invitations,
    parent: rootRouteRef,
    path: '/users/invitations',
  });

export const [userRouteImplRef, userRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.user,
  parent: rootRouteRef,
  path: '/users/:id',
});

export const [agentsRouteImplRef, agentsRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.agents,
  parent: rootRouteRef,
  path: '/agents',
});

export const [agentRouteImplRef, agentRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.agent,
  parent: rootRouteRef,
  path: '/agents/:id',
});

export const [apiClientsRouteImplRef, apiClientsRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.apiClients,
    parent: rootRouteRef,
    path: '/api-clients',
  });

export const [apiClientRouteImplRef, apiClientRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.apiClient,
    parent: rootRouteRef,
    path: '/api-clients/:id',
  });

export const [clientsRouteImplRef, clientsRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.clients,
  parent: rootRouteRef,
  path: '/clients',
});

export const [clientRouteImplRef, clientRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.client,
  parent: rootRouteRef,
  path: '/clients/:id',
});

export const [clientSchemaRouteImplRef, clientSchemaRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.clientSchema,
    parent: rootRouteRef,
    path: '/clients/schema',
  });

export const [clientMonitoringRouteImplRef, clientMonitoringRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.clientMonitoring,
    parent: rootRouteRef,
    path: '/clients/monitoring',
  });

export const [rolesRouteImplRef, rolesRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.roles,
  parent: rootRouteRef,
  path: '/roles',
});

export const [oauthAppsRouteImplRef, oauthAppsRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.oauthApps,
    parent: rootRouteRef,
    path: '/oauth-apps',
  });

export const [oauthAppRouteImplRef, oauthAppRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.oauthApp,
  parent: rootRouteRef,
  path: '/oauth-apps/:id',
});

export const [metricsDataWarehouseRouteImplRef, metricsDataWarehouseRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.metricsDataWarehouse,
    parent: rootRouteRef,
    path: '/metrics-datawarehouse',
  });

export const [reportsRouteImplRef, reportsRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.reports,
  parent: rootRouteRef,
  path: '/reports',
});

export const [githubRouteImplRef, githubRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.github,
  parent: rootRouteRef,
  path: '/github',
});

export const [cursorIntegrationRouteImplRef, cursorIntegrationRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.cursorIntegration,
    parent: rootRouteRef,
    path: '/cursor-integration',
  });

export const [workflowsRouteImplRef, workflowsRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.workflows,
    parent: rootRouteRef,
    path: '/workflows',
  });

export const [workflowRouteImplRef, workflowRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.workflow,
  parent: rootRouteRef,
  path: '/workflows/:id',
});

export const [workflowInstancesRouteImplRef, workflowInstancesRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.workflowInstances,
    parent: rootRouteRef,
    path: '/workflows/:id/instances',
  });

export const [
  workflowInstanceOverviewRouteImplRef,
  workflowInstanceOverviewRouteRef,
] = createSubRouteRefsPair({
  id: RoutesIds.workflowInstanceOverview,
  parent: rootRouteRef,
  path: '/workflows/:id/instances/:instance',
});

export const [
  workflowInstanceEventsRouteImplRef,
  workflowInstanceEventsRouteRef,
] = createSubRouteRefsPair({
  id: RoutesIds.workflowInstanceEvents,
  parent: rootRouteRef,
  path: '/workflows/:id/instances/:instance/events',
});

export const [workflowLogsRouteImplRef, workflowLogsRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.workflowLogs,
    parent: rootRouteRef,
    path: '/workflows/:id/logs',
  });
export const [workflowTunnelsRouteImplRef, workflowTunnelsRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.workflowTunnels,
    parent: rootRouteRef,
    path: '/workflows/:id/tunnels',
  });

export const [
  flagAppliedConnectionsRouteImplRef,
  flagAppliedConnectionsRouteRef,
] = createSubRouteRefsPair({
  id: RoutesIds.flagAppliedConnections,
  parent: rootRouteRef,
  path: '/connections/flag-applied',
});

export const [
  flagAppliedConnectionRouteImplRef,
  flagAppliedConnectionRouteRef,
] = createSubRouteRefsPair({
  id: RoutesIds.flagAppliedConnection,
  parent: rootRouteRef,
  path: '/connections/flag-applied/:id',
});

export const [eventConnectionsRouteImplRef, eventConnectionsRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.eventConnections,
    parent: rootRouteRef,
    path: '/connections/event',
  });

export const [eventConnectionRouteImplRef, eventConnectionRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.eventConnection,
    parent: rootRouteRef,
    path: '/connections/event/:id',
  });

export const [activityFeedsRouteImplRef, activityFeedsRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.activityFeeds,
    parent: rootRouteRef,
    path: '/activity-feeds',
  });

export const [environmentsRouteImplRef, environmentsRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.environments,
    parent: rootRouteRef,
    path: '/environments',
  });

export const [assignmentTablesRouteImplRef, assignmentTablesRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.assignmentTables,
    parent: rootRouteRef,
    path: '/assignment-tables',
  });

export const [assignmentTableRouteImplRef, assignmentTableRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.assignmentTable,
    parent: rootRouteRef,
    path: '/assignment-tables/:id',
  });

export const [assignmentTablesEditRouteImplRef, assignmentTablesEditRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.assignmentTableEdit,
    path: '/assignment-tables/:id/edit',
    parent: rootRouteRef,
  });

export const [
  assignmentTablesCreateRouteImplRef,
  assignmentTablesCreateRouteRef,
] = createSubRouteRefsPair({
  id: RoutesIds.assignmentTablesCreate,
  path: '/assignment-tables-create',
  parent: rootRouteRef,
});

export const [factTablesRouteImplRef, factTablesRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.factTables,
    path: '/fact-tables',
    parent: rootRouteRef,
  });

export const [factTablesCreateRouteImplRef, factTablesCreateRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.factTablesCreate,
    path: '/fact-tables-create',
    parent: rootRouteRef,
  });

export const [factTableRouteImplRef, factTableRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.factTable,
    path: '/fact-tables/:id',
    parent: rootRouteRef,
  });

export const [factTableEditRouteImplRef, factTableEditRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.factTableEdit,
    path: '/fact-tables/:id/edit',
    parent: rootRouteRef,
  });

export const [entitiesRouteImplRef, entitiesRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.entities,
  path: '/entities',
  parent: rootRouteRef,
});

export const [entityRelationTableRouteImplRef, entityRelationTableRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.entityRelationTable,
    path: '/entities/:entityId/entityRelationTables/:entityRelationTableId',
    parent: rootRouteRef,
  });

export const [
  entityRelationTablesCreateRouteImplRef,
  entityRelationTablesCreateRouteRef,
] = createSubRouteRefsPair({
  id: RoutesIds.entityRelationTableCreate,
  path: '/entity-relation-table-create/:parentEntityId',
  parent: rootRouteRef,
});

export const [entityRouteImplRef, entityRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.entity,
  path: '/entities/:id',
  parent: rootRouteRef,
});

export const [dimensionTablesRouteImplRef, dimensionTablesRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.dimensionTables,
    path: '/dimension-tables',
    parent: rootRouteRef,
  });

export const [dimensionTableRouteImplRef, dimensionTableRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.dimensionTable,
    path: '/dimension-tables/:id',
    parent: rootRouteRef,
  });

export const [dimensionTableRouteEditImplRef, dimensionTableRouteEditRef] =
  createSubRouteRefsPair({
    id: RoutesIds.dimensionTableEdit,
    path: '/dimension-tables/:id/edit',
    parent: rootRouteRef,
  });

export const [dimensionTableCreateRouteImplRef, dimensionTableCreateRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.dimensionTablesCreate,
    path: '/dimension-tables-create',
    parent: rootRouteRef,
  });

export const [labelsRouteImplRef, labelsRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.labels,
  parent: rootRouteRef,
  path: '/labels',
});

export const [labelRouteImplRef, labelRouteRef] = createSubRouteRefsPair({
  id: RoutesIds.label,
  parent: rootRouteRef,
  path: '/labels/:id',
});

export const [dataAgentRouteImplRef, dataAgentRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.dataAgent,
    parent: rootRouteRef,
    path: '/data-agent',
  });

// default routes/routes to be used by other plugins
export const Routes = {
  admin: adminRouteImplRef,
  notifications: notificationsRouteImplRef,
  secrets: workflowSecretsRouteImplRef,
  secret: workflowSecretRouteImplRef,
  policies: policiesRouteImplRef,
  groups: groupsRouteImplRef,
  group: groupRouteImplRef,
  users: usersRouteImplRef,
  user: userRouteImplRef,
  invitations: invitationsRouteImplRef,
  agents: agentsRouteImplRef,
  agent: agentRouteImplRef,
  apiClients: apiClientsRouteImplRef,
  apiClient: apiClientRouteImplRef,
  clients: clientsRouteImplRef,
  client: clientRouteImplRef,
  clientSchema: clientSchemaRouteImplRef,
  clientMonitoring: clientMonitoringRouteImplRef,
  roles: rolesRouteImplRef,
  oauthApps: oauthAppsRouteImplRef,
  oauthApp: oauthAppRouteImplRef,
  metricsDataWarehouse: metricsDataWarehouseRouteImplRef,
  reports: reportsRouteImplRef,
  workflows: workflowsRouteImplRef,
  workflow: workflowRouteImplRef,
  workflowInstances: workflowInstancesRouteImplRef,
  workflowInstanceOverview: workflowInstanceOverviewRouteImplRef,
  workflowInstanceEvents: workflowInstanceEventsRouteImplRef,
  workflowLogs: workflowLogsRouteImplRef,
  workflowTunnels: workflowTunnelsRouteImplRef,
  flagAppliedConnections: flagAppliedConnectionsRouteImplRef,
  flagAppliedConnection: flagAppliedConnectionRouteImplRef,
  eventConnections: eventConnectionsRouteImplRef,
  eventConnection: eventConnectionRouteImplRef,
  activityFeeds: activityFeedsRouteImplRef,
  environments: environmentsRouteImplRef,
  assignmentTables: assignmentTablesRouteImplRef,
  assignmentTable: assignmentTableRouteImplRef,
  assignmentTablesCreate: assignmentTablesCreateRouteImplRef,
  assignmentTableEdit: assignmentTablesEditRouteImplRef,
  factTables: factTablesRouteImplRef,
  factTable: factTableRouteImplRef,
  factTablesCreate: factTablesCreateRouteImplRef,
  factTableEdit: factTableEditRouteImplRef,
  entities: entitiesRouteImplRef,
  entity: entityRouteImplRef,
  entityRelationTable: entityRelationTableRouteImplRef,
  entityRelationTableCreate: entityRelationTablesCreateRouteImplRef,
  dimensionTables: dimensionTablesRouteImplRef,
  dimensionTable: dimensionTableRouteImplRef,
  dimensionTableEdit: dimensionTableRouteEditImplRef,
  dimensionTablesCreate: dimensionTableCreateRouteImplRef,
  github: githubRouteImplRef,
  cursorIntegration: cursorIntegrationRouteImplRef,
  labels: labelsRouteImplRef,
  label: labelRouteImplRef,
  dataAgent: dataAgentRouteImplRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // sub-routes within the plugin
  admin: adminRouteRef,
  notifications: notificationsRouteRef,
  secrets: workflowSecretsRouteRef,
  secret: workflowSecretRouteRef,
  policies: policiesRouteRef,
  groups: groupsRouteRef,
  group: groupRouteRef,
  users: usersRouteRef,
  user: userRouteRef,
  invitations: invitationsRouteRef,
  agents: agentsRouteRef,
  agent: agentRouteRef,
  apiClients: apiClientsRouteRef,
  apiClient: apiClientRouteRef,
  clients: clientsRouteRef,
  client: clientRouteRef,
  clientSchema: clientSchemaRouteRef,
  clientMonitoring: clientMonitoringRouteRef,
  roles: rolesRouteRef,
  oauthApps: oauthAppsRouteRef,
  oauthApp: oauthAppRouteRef,
  metricsDataWarehouse: metricsDataWarehouseRouteRef,
  reports: reportsRouteRef,
  workflows: workflowsRouteRef,
  workflow: workflowRouteRef,
  workflowInstances: workflowInstancesRouteRef,
  workflowInstanceOverview: workflowInstanceOverviewRouteRef,
  workflowInstanceEvents: workflowInstanceEventsRouteRef,
  workflowLogs: workflowLogsRouteRef,
  workflowTunnels: workflowTunnelsRouteRef,
  flagAppliedConnections: flagAppliedConnectionsRouteRef,
  flagAppliedConnection: flagAppliedConnectionRouteRef,
  eventConnections: eventConnectionsRouteRef,
  eventConnection: eventConnectionRouteRef,
  activityFeeds: activityFeedsRouteRef,
  assignmentTables: assignmentTablesRouteRef,
  assignmentTable: assignmentTableRouteRef,
  assignmentTablesCreate: assignmentTablesCreateRouteRef,
  assignmentTableEdit: assignmentTablesEditRouteRef,
  factTables: factTablesRouteRef,
  factTable: factTableRouteRef,
  factTablesCreate: factTablesCreateRouteRef,
  factTableEdit: factTableEditRouteRef,
  entities: entitiesRouteRef,
  entity: entityRouteRef,
  entityRelationTable: entityRelationTableRouteRef,
  entityRelationTableCreate: entityRelationTablesCreateRouteRef,
  dimensionTables: dimensionTablesRouteRef,
  dimensionTable: dimensionTableRouteRef,
  dimensionTableEdit: dimensionTableRouteEditRef,
  dimensionTablesCreate: dimensionTableCreateRouteRef,
  environments: environmentsRouteRef,
  github: githubRouteRef,
  cursorIntegration: cursorIntegrationRouteRef,
  labels: labelsRouteRef,
  label: labelRouteRef,
  dataAgent: dataAgentRouteRef,
} satisfies Record<RoutesIds, ExternalRouteRef> &
  Record<ExternalRoutesIds, ExternalRouteRef>;
